import AddressAutocomplete from "./controllers/address_autocomplete"
import Autocomplete        from "./controllers/autocomplete"
import Clipboard           from "@stimulus-components/clipboard"
import CollapsiblePanel    from "./controllers/collapsible_panel"
import Dialog              from "./controllers/dialog"
import ImageUpload         from "./controllers/image_upload"
import Map                 from "./controllers/map"
import Notification        from "@stimulus-components/notification"
import Popover             from "@stimulus-components/popover"
import Print               from "./controllers/print"
import ReadMore            from "@stimulus-components/read-more";
import Reveal              from "./controllers/reveal"
import TextareaAutogrow    from "stimulus-textarea-autogrow"
import Toggle              from "./controllers/toggle"
export { default as colors } from './colors';

const start = function(application) {
  application.register("address-autocomplete", AddressAutocomplete)
  application.register("autocomplete",         Autocomplete)
  application.register("clipboard",            Clipboard)
  application.register("collapsible-panel",    CollapsiblePanel)
  application.register("dialog",               Dialog)
  application.register("image-upload",         ImageUpload)
  application.register("map",                  Map)
  application.register("notification",         Notification)
  application.register("popover",              Popover)
  application.register("print",                Print)
  application.register("read-more",            ReadMore)
  application.register("reveal",               Reveal)
  application.register("textarea-autogrow",    TextareaAutogrow)
  application.register("toggle",               Toggle)
}

export default { start }